import React, { FC } from 'react'
import { Box } from 'front-end/src/components'
import { brandColors } from 'shared/basicPalette'
import { BoxProps } from '@chakra-ui/react'

type IconTickColor = 'green' | 'red' | 'grey'

type IconTickSize = 'small' | 'normal' | 'big'

export type IIconTick = {
  color?: IconTickColor
  size?: IconTickSize
}

const getColor = (colorType) => {
  switch (colorType) {
    case 'red': {
      return brandColors.red.mid
    }
    case 'grey': {
      return brandColors.grey.lighter
    }
    default: {
      return brandColors.green.mid
    }
  }
}

const IconTick: FC<BoxProps & IIconTick> = (props) => {
  const { color, size = 'small', ...rest } = props
  return (
    <Box
      display="inline-block"
      position="relative"
      bgColor={getColor(color)}
      borderRadius="50%"
      overflow="hidden"
      boxSize={size === 'normal' ? '24px' : size === 'big' ? '36px' : '16px'}
      _after={{
        content: '""',
        position: 'absolute',
        width: '45%',
        height: '20%',
        background: 'transparent',
        top: '50%',
        left: '50%',
        border: '1px solid white',
        borderTop: 'none',
        borderRight: 'none',
        transform: 'translate(-50%, -70%) rotate(-50deg)'
      }}
      className={'IconTick'}
      {...rest}
    />
  )
}

export default IconTick
